import { callApi } from "@/api/callApi";
import { API_ENDPOINT } from "@/api/constant";
import type { FetchNotificationsParams, MarkSeenPayload, NotificationsListResponse, SeenNotificationResponse, UnseenCountResponse } from "@/interface/notification.interface";

export const NotificationService = {
  getList: async (
    params: FetchNotificationsParams,
  ): Promise<NotificationsListResponse> => {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        query.append(key, String(value));
      }
    });

    return callApi<NotificationsListResponse>(
      `${API_ENDPOINT.notification}?${query.toString()}`,
      {
        method: "GET",
      },
    );
  },


  getUnseenCount: async (): Promise<UnseenCountResponse> => {
    return callApi<UnseenCountResponse>(
      `${API_ENDPOINT.notification}/count/unseen`,
      {
        method: "GET",
      },
    );
  },

  markAsSeen: async (
    notificationIds: string[],
    seen: boolean = true,
  ): Promise<{ status: boolean; message: string }> => {
    const payload: MarkSeenPayload = { seen, notificationIds };
    return callApi<SeenNotificationResponse>(
      `${API_ENDPOINT.notification}/seen`,
      {
        method: "PUT",
        data: payload, 
      },
    );
  },

 
    delete: async (
    notificationIds: string[],
  ): Promise<{ status: boolean; message: string }> => {
    return callApi<{ status: boolean; message: string }>(
      `${API_ENDPOINT.notification}`,
      {
        method: "DELETE",
        data: { notificationIds },
      },
    );
  },
};
